import { overlay } from 'overlay-kit';
import { LoadingImage } from '@/components/Loading';
import { DelayedLoadingFallback } from '@/shared/components/DelayedLoadingFallback';

// ponytail: fixed inset-0 = 뷰포트 전체. 조상에 transform/filter/will-change 없어야 동작(현재 카드·헤더 모두 없음). 생기면 createPortal(document.body)로 전환.
export function FullscreenLoading() {
  return <DelayedLoadingFallback delayMS={500} data-sentry-element="DelayedLoadingFallback" data-sentry-component="FullscreenLoading" data-sentry-source-file="FullscreenLoading.tsx">
      <div role="status" className="fixed inset-0 z-modal flex items-center justify-center bg-dimmed">
        <LoadingImage className="size-[64px] brightness-0 invert" data-sentry-element="LoadingImage" data-sentry-source-file="FullscreenLoading.tsx" />
      </div>
    </DelayedLoadingFallback>;
}
const FULLSCREEN_LOADING_OVERLAY_ID = 'fullscreen-loading';

// 임퍼러티브 오버레이. overlay-kit 이 앱 루트(OverlayProvider)에 포탈 마운트하므로
// 호출한 컴포넌트의 DOM 서브트리(예: <Link> 앵커) 밖에 렌더된다 → 오버레이 클릭이
// 조상 <a> 로 버블링돼 의도치 않은 네비게이션을 유발하는 문제가 원천 차단된다.
// 고정 overlayId 로 싱글턴 보장. confirmDialog/alertDialog 와 동일 메커니즘.
export const fullscreenLoading = {
  open() {
    overlay.open(() => <FullscreenLoading />, {
      overlayId: FULLSCREEN_LOADING_OVERLAY_ID
    });
  },
  close() {
    overlay.unmount(FULLSCREEN_LOADING_OVERLAY_ID);
  }
};